@if (tooltip$ | async; as tooltip) {
  <div
    class="absolute border rounded-large white-bg font-body-1 flex flex--middle flex--center tooltip-padding ps-xsmall-x ps-xxsmall-y"
    [ngStyle]="{ top: tooltip.top, left: tooltip.left, opacity: tooltip.visible ? 1 : 0 }"
  >
    <div class="ball nordic-blue-900-bg"></div>
    <div class="bold-type ms-xsmall-x">
      {{
        tooltip.unit === '€'
          ? ({ amount: tooltip.yValue.toString(), currencyCode: 'EUR' } | finPrice: { roundPrice: true })
          : (tooltip.yValue | number: '1.0-0')
      }}
      {{ tooltip.unit === '€' ? '' : (tooltip.unit | finLocalization) }}
    </div>
    <div>
      {{ tooltip.xAxisType === 'date' ? (tooltip.xValue | finDateFormat: 'MMMM yyyy') : tooltip.xValue }}
    </div>
  </div>
}
